"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_calendar__11__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "778e5f74-772e-4164-8450-d6131ce8cede",
    "data-name": "Apps_ic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "253b2310-e757-4b8e-85ce-a40b8e5262d7",
    x1: 59.82,
    y1: 28.29,
    x2: 179.23,
    y2: 147.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "calendar-11-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "fd632985-92a2-4456-983a-89ee888f3d6d",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fb30b783-f8b9-4f44-b641-071cef410a95",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9a9536a1-2ee5-4ba3-8a3f-df9b82f9a73f",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b02ad461-6241-48c0-847c-9a6f0817ae7e",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dac86550-e121-4c88-91da-f408593c97e7",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "40e320fc-8793-48e2-b533-1f9f7157724c",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2f824f95-94b2-44f3-a6b3-7436181d994c",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,152a16,16,0,0,0,16,16H152a16,16,0,0,0,16-16V64H24Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,166H40a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16H152a16,16,0,0,0,16-16v-2A16,16,0,0,1,152,166Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,24H32a8,8,0,0,0-8,8V64H168V32A8,8,0,0,0,160,24ZM52,40a4,4,0,1,1,4-4A4,4,0,0,1,52,40Zm88,0a4,4,0,1,1,4-4A4,4,0,0,1,140,40Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 62,
    width: 144,
    height: 2,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,30a4,4,0,0,0-3.86,5,4,4,0,0,1,7.72,0A4,4,0,0,0,52,30Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,30a4,4,0,0,0-3.86,5,4,4,0,0,1,7.72,0A4,4,0,0,0,140,30Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "50011a28-5731-4c18-a2f9-f8d1b16755ca",
    "data-name": "Bounding Box",
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.51,64.13l-123.33-.2h-20v.59L128.34,168H152a19,19,0,0,0,4.24-.37,16.3,16.3,0,0,0,8.52-5.64,15.86,15.86,0,0,0,3.39-9.81V64.79Z",
    transform: "translate(0 0)",
    opacity: 0.1,
    fill: "url(#253b2310-e757-4b8e-85ce-a40b8e5262d7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.89,24.63A7.92,7.92,0,0,1,31.19,24,7.92,7.92,0,0,0,28.89,24.63Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.54,25.37a8.1,8.1,0,0,0-1.7,1.55A8.1,8.1,0,0,1,27.54,25.37Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  })))))))), /*#__PURE__*/React.createElement("path", {
    d: "M75.43,137.46V92.09L64,99.74l-3-4.38L76.23,84.83h5.34v52.62Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.33,137.46V92.09l-11.4,7.65-3-4.38,15.15-10.53h5.34v52.62Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }));
}

var _default = ic_calendar__11__dark;
exports.default = _default;